const oneDay = 1000 * 3600 * 24;

export const unifyDateFormat = (date: Date | string, onlyDate = true): Date => {
  if (typeof date === 'string') date = date.replaceAll('-', '/');

  date = new Date(date);
  if (onlyDate) date.setHours(0, 0, 0, 0);

  return date;
};

export const diffDays = (to: Date | string, from: Date | string = new Date()): number => {
  to = unifyDateFormat(to, true);
  from = unifyDateFormat(from, true);

  // round, ne ceil: obě data jsou lokální půlnoc, přes změnu času (DST) se rozdíl
  // liší o ±1 h a ceil by přes podzimní přechod nadhodnotil o celý den
  return Math.round((to.getTime() - from.getTime()) / oneDay);
};

export type RelativeDurationUnit = 'Days' | 'Months' | 'Years';

const daysPerMonth = 30;
const daysPerYear = 365;

/**
 * Rozloží počet dní na jedinou „největší" jednotku (rok / měsíc / den) pro
 * lidsky čitelný relativní popis – zaokrouhleně, vždy jen jedna jednotka.
 * Vrací absolutní hodnotu + jednotku; směr (zbývá / před) řeší volající podle znaménka.
 */
export const relativeDuration = (days: number): { unit: RelativeDurationUnit; count: number } => {
  const abs = Math.abs(days);

  if (abs >= daysPerYear) return { unit: 'Years', count: Math.floor(abs / daysPerYear) };
  if (abs > daysPerMonth) return { unit: 'Months', count: Math.round(abs / daysPerMonth) };
  return { unit: 'Days', count: abs };
};

export const formatDate = (date: Date | string, apiFormat?: boolean): string => {
  date = unifyDateFormat(date);

  if (apiFormat) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }
  return new Intl.DateTimeFormat('cs-CZ', { dateStyle: 'long' }).format(date);
};

export const formatDateTime = (date: Date | string): string => {
  date = unifyDateFormat(date, false);

  return new Intl.DateTimeFormat('cs-CZ', { dateStyle: 'long', timeStyle: 'short' }).format(date);
};

export const formatDateMonthYear = (date: Date | string): string => {
  date = unifyDateFormat(date);

  return new Intl.DateTimeFormat('cs-CZ', { month: 'long', year: 'numeric' }).format(date);
};

export const addDays = (date: Date | string, days: number): Date => {
  date = new Date(date);

  date.setDate(date.getDate() + days);
  return date;
};
